import { action } from 'satcheljs';
import { default as DatapointOptions, CustomData } from './types/DatapointOptions';

export const logUsage = action(
    'LOG_USAGE',
    (eventName: string, customData?: CustomData, options?: DatapointOptions) => ({
        eventName,
        customData,
        options,
    })
);

export const setTraceDatapoints = action('SET_TRACE_DATAPOINTS', (value: boolean) => ({
    value,
}));
